import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

/**
 * Inline "access blocked" placeholder for partial content.
 *
 * Tier 3 of the permission UX pattern:
 *   Page blocked   → UnauthorizedComponent (full-page, via guard)
 *   Button blocked → clbRequires directive (toast on click)
 *   Partial blocked → THIS component (inline, via appCan else template)
 *
 * Usage:
 *   <ng-template #blocked><app-permission-blocked /></ng-template>
 *   <div *appCan="'edit'; else blocked"> ... </div>
 *
 *   Or with a custom message:
 *   <app-permission-blocked message="You can't edit this section." />
 */
@Component({
  selector: 'app-permission-blocked',
  standalone: true,
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="flex items-center gap-2 text-[13px] text-gray-400 px-3 py-2.5
                rounded-lg bg-gray-50 border border-gray-100 w-full">
      <mat-icon class="!text-[15px] !w-[15px] !h-[15px] shrink-0 text-gray-300" svgIcon="c:lock"></mat-icon>
      <span>{{ message }}</span>
    </div>
  `,
})
export class PermissionBlockedComponent {
  @Input() message = "You don't have access to this section.";
}
